import { connect } from 'react-redux';
import { selectIsDesktop } from 'selectors/ui';
import Controls from './Controls';

const mapStateToProps = state => ({
  isDesktop: selectIsDesktop(state),
});

export default connect(mapStateToProps)(Controls);
